module.exports = __webpack_public_path__ + "img/表1-9学习成果评价表.606074de.png";